import { baseUrl } from "../config/endpoints"
import axios from "axios"

export default class TokenAPI {
  instance: any
  token: any
  getRefreshToken: any

  constructor() {
    this.instance = axios.create({
      baseURL: baseUrl,
    })

    this._initializeRequestInterceptor()
    this._initializeResponseInterceptor()
  }

  _initializeRequestInterceptor = () => {
    this.instance.interceptors.request.use(this._handleRequest)
  }

  _initializeResponseInterceptor = () => {
    this.instance.interceptors.response.use(
      this._handleResponse,
      this._handleError,
    )
  }

  _handleResponse = (data: any) => data

  _handleError = async ({ response, config }: any) => {
    return Promise.resolve(response)
  }

  _handleRequest = async (axiosConfig: any) => {
    return axiosConfig
  }

  getToken = (data: any) => {
    return this.instance({
      method: this.token.Method,
      url: this.token.EndPoint,
      headers: { "Content-Type": "application/x-www-form-urlencoded" },
      data,
    })
  }
}
